import React, { useEffect, useState } from "react";
import "../../Styles/TeamCreate.css";
import {
  getMarketingExecutiveApi,
  getRegionalManagerApi,
  getTeamListMethod,
  teamCreateApi,
} from "../../Services/Operations/ProductAPI";
import { useSelector } from "react-redux";
import Header from "../../Core/Header";
import { Section } from "../../Core/Section";
import { toast } from "react-toastify";

const TeamCreate = () => {
  const token = useSelector((state) => state.user.token);

  const [teamName, setTeamName] = useState("");
  const [regionalManagers, setRegionalManagers] = useState([]);
  const [marketingExecutives, setMarketingExecutives] = useState([]);

  const [regionalManagerId, setRegionalManagerId] = useState("");
  const [selectedMarketingIds, setSelectedMarketingIds] = useState([]);
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);

  const[teamList,setTeamList]=useState([])
  const[view,setView]=useState(0)


  const handleFetchTeamList=async()=>{
    try {
      const response=await getTeamListMethod(token)
      console.log("Team list fetched",response);
      if(response.status===200){
        setTeamList(response.data)
      }
      
    } catch (error) {
      console.log(error);
      
    }
  }

  useEffect(() => {
    const fetchManagers = async () => {
      try {
        const regionalResponse = await getRegionalManagerApi(token);
        const executiveResponse = await getMarketingExecutiveApi(token);
        setRegionalManagers(regionalResponse);
        setMarketingExecutives(executiveResponse);
      } catch (error) {
        console.error("Error fetching managers:", error);
      }
    };
    fetchManagers();
    handleFetchTeamList()
  }, [token]);

  const handleCheckboxChange = (id) => {
    setSelectedMarketingIds((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id]
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!teamName || !regionalManagerId || selectedMarketingIds.length === 0) {
      alert("Please fill all fields");
      return;
    }

    const teamData = {
      teamName,
      regionalManagerId: parseInt(regionalManagerId),
      marketingExecutiveIds: selectedMarketingIds.map(Number),
    };

    try {
      setLoading(true);
      const regionalResponse = await teamCreateApi(teamData, token);
      console.log("regionalResponse : ", regionalResponse);
      if(regionalResponse.status === 200){
        toast.success(regionalResponse.data.message)
      }
      else{
        toast.error(regionalResponse.data.message)
      }
    } catch (error) {
      console.error("Error creating team:", error);
      // toast.error(regionalResponse.data.message)
      setResponse(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div id="main_content">
      <Header />
      <div className="page">
        <Section />
        <div className="page-container1">
          <div style={{width:"100%",display:"flex",flexDirection:"column",gap:"30px"}}>
          <form className="card1" onSubmit={handleSubmit}>
            <h1 className="title">Create Marketing Team</h1>

            <label className="label">Team Name</label>
            <input
              type="text"
              value={teamName}
              onChange={(e) => setTeamName(e.target.value)}
              className="input"
              placeholder="Enter team name"
            />

            <label className="label">Marketing Executive (Senior)</label>
            <select
              value={regionalManagerId}
              onChange={(e) => setRegionalManagerId(e.target.value)}
              className="input"
            >
              <option value="">Select Senior Marketing Executive</option>
              {regionalManagers.map((manager) => (
                <option key={manager.employeeId} value={manager.employeeId}>
                  {manager.firstName}
                </option>
              ))}
            </select>

            <label className="label">Marketing Executives (junior)</label>
            <div className="checkbox-group">
              {marketingExecutives.map((exec) => (
                <label key={exec.employeeId} className="checkbox-label">
                  <input
                    type="checkbox"
                    value={exec.employeeId}
                    checked={selectedMarketingIds.includes(exec.employeeId)}
                    onChange={() => handleCheckboxChange(exec.employeeId)}
                  />
                  {exec.firstName}
                </label>
              ))}
            </div>

            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? "Submitting..." : "Create Team"}
            </button>

            {response && (
              <div className="success-message">
                ✅ Team Created!
                <pre className="json-preview">
                  {JSON.stringify(response, null, 2)}
                </pre>
              </div>
            )}
          </form>

          <table className="table table-hover table-vcenter table-striped mb-0 text-nowrap">
            <thead>
              <tr>
                <th>Id</th>
                <th>Team Name</th>
                <th>Regional Manager Name</th>
                <th>Date </th>
                <th>Marketing Executives</th>
              </tr>
            </thead>
            <tbody>
              {
                teamList.map((item,ind)=>(
                  <tr>
                    <th>{ind+1}</th>
                    <th>{item.teamName}</th>
                    <th>{item.regionalManagerName}</th>
                    <th>{item.createdAt}</th>
                    <th onClick={()=>setView(item.id)}>
                      <i className="fa fa-eye" />
                      {
                        view===item.id && 
                        <div style={{position:"absolute",zIndex:888,width:"200px",height:"150px",backgroundColor:"white",border:"0.4px solid grey",padding:"10px"}}>
                          <p onClick={()=>setView(0)}
                          style={{cursor:"pointer",position:"absolute",top:"10px",right:"10px",zIndex:999}}>X</p>

                          {item.marketingExecutives.map((i,indx)=>
                          <p>{indx+1}.{i.firstName}</p>)}
                        </div>
                      }
                      </th>
                  </tr>
                ))
              }
            </tbody>
          </table>
</div>

         </div>

          
        
      </div>
    </div>
  );
};

export default TeamCreate;
